import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap-5';

import { connect } from 'react-redux';
import { deleteCommission } from 'bundles/apex/deals/show/store/deal/actions';

import { Button } from 'components/ui/button';
import Modal from 'components/modal';

export function DeleteBrokerModal({ commission, deleteCommission, label, onClose }) {
  const [deleting, setDeleting] = useState();
  const [errors, setErrors] = useState();

  async function deleteContact() {
    try {
      setDeleting(true);
      await deleteCommission(commission);
      onClose();
    } catch (errors) {
      setErrors(errors);
    } finally {
      setDeleting(false);
    }
  }

  let body;
  if (errors) {
    // TODO: Show the actual errors here - clean them up so they read nice and just show them?
    body = (
      <Alert variant="warning">
        The broker could not be removed.
        Removing their commission would invalidate the voucher for this deal.
      </Alert>
    );
  } else {
    body = `Are you sure you want to remove this ${label}?`;
  }

  return (
    <Modal
      show={!!commission}
      onClose={onClose}
      onShow={() => setErrors(null)}
    >
      <Modal.Header closeButton>
        Remove Broker
      </Modal.Header>

      <Modal.Body>
        {body}
      </Modal.Body>

      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onClose} />

        {!errors &&
          <Button disabled={deleting} label="Remove Broker" variant="destructive" onClick={deleteContact} />
        }
      </Modal.Footer>
    </Modal>
  );
}

DeleteBrokerModal.propTypes = {
  commission: PropTypes.object,
  deleteCommission: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  deleteCommission,
};

export default connect(null, mapDispatchToProps)(DeleteBrokerModal);
